import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  margin-right: 13px;
`;

const Text = styled.span`
  color: ${props => props.theme.secondaryColor};
  font: ${props => props.theme.fontWeightHeavy} 14px/110% ${props => props.theme.fontFamilyBody};
  text-transform: uppercase;
  &:hover {
    cursor: pointer;
    color: ${props => props.theme.bodyColor};
  }
`;

export default function NavItem({
  title, onClick,
}) {
  const handleClick = e => {
    e.preventDefault();
    onClick();
  };
  return (
    <Container>
      <Text onClick={handleClick}>{title}</Text>
    </Container>
  );
}

NavItem.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
